import { getLangDir } from '@tesla/design-system';
import { getLocalMonthYear } from '@tesla/design-system';
import { iconChevronSmall270, iconChevronSmall90 } from '@tesla/design-system-icons';
import React from 'react';
import { Icon } from '../icon/icon.js';
export const MonthHeader = ({ ariaLabelMonthPicker = 'Use left or right arrow keys to increment the month', date: selectedDate, locale = 'en-US', months, onNextClick, onPrevClick, ...rest }) => {
    // Create a fallback to still render the correct month and year,
    // even if no date is passed in at first (allows for no default selected date)
    const date = selectedDate || new Date();
    const prevMonth = new Date(date);
    prevMonth.setDate(1);
    prevMonth.setMonth(date.getMonth() - 1);
    const nextMonth = new Date(date);
    nextMonth.setDate(1);
    nextMonth.setMonth(date.getMonth() + 1);
    const handleStepMonth = (e) => {
        const dir = getLangDir(e.target);
        if ((dir === 'ltr' && e.key === 'ArrowRight') || (dir === 'rtl' && e.key === 'ArrowLeft')) {
            e.preventDefault();
            if (onNextClick)
                onNextClick();
        }
        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            if (onPrevClick)
                onPrevClick();
        }
    };
    return (React.createElement("div", { "aria-label": ariaLabelMonthPicker, className: "tds-date-picker-month", onKeyDown: handleStepMonth, tabIndex: 0, ...rest },
        React.createElement("button", { "aria-label": getLocalMonthYear(prevMonth, locale), onClick: onPrevClick, tabIndex: -1, type: "button" },
            React.createElement(Icon, { data: iconChevronSmall270 })),
        React.createElement("label", { "aria-live": "polite" }, getLocalMonthYear(date, locale)),
        months === 2 && React.createElement("label", null, getLocalMonthYear(nextMonth, locale)),
        React.createElement("button", { "aria-label": getLocalMonthYear(nextMonth, locale), onClick: onNextClick, tabIndex: -1, type: "button" },
            React.createElement(Icon, { data: iconChevronSmall90 }))));
};
